import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat.js';
import utc from 'dayjs/plugin/utc.js';

dayjs.extend(LocalizedFormat);
dayjs.extend(utc);

export const formatDateTime = (date: dayjs.ConfigType) => dayjs.utc(date).format('LLL');

export const formatDate = (date: dayjs.ConfigType) => dayjs(date).format('LL');

export const getDaysDifference = (fromDate: dayjs.ConfigType, toDate: dayjs.ConfigType) =>
  dayjs(toDate).diff(fromDate, 'day');
